'use strict';

require('./src/scss/init.scss');
